import React, { useState, useEffect, useLayoutEffect } from 'react';
import getClientDocuments from '../../api/clients/getClientDocuments';
import uploadFileToClient from '../../api/clients/uploadFileToClient';
import { useParams } from 'react-router-dom';

// components
import ModalAccept from '../../components/ModalAccept/ModalAccept';
import HookForm from '../../components/HookForm/HookForm';
import SelectClienDocumentTypes from '../../components/Selects/SelectClientDocumentTypes';
import DocsInput from '../../components/Inputs/DocsInput/DocsInput';
import DeleteButton from '../../components/DeleteButton/DeleteButton';
import AddButton from '../../components/AddButton/AddButton';
import Button from '../../components/Button/Button';
import Loader from '../../components/Loader/Loader';

const formStyles = {
  documents: { display: 'flex', flexWrap: 'wrap', gap: '20px' },
};

const ClientsDocs = () => {
  const [clientDocs, setClientDocs] = useState([]);
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [documentIndex, setDocumentIndex] = useState(null);
  const [deletedDocument, setDeletedDocument] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAddForm = (form, setForm) => {
    form.push([
      {
        name: `documentType_${form.length + 1}`,
        component: SelectClienDocumentTypes,
        label: 'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
        placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
        style: { width: '49%' },
      },
      {
        name: `document_${form.length + 1}`,
        component: DocsInput,
        text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
        label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
        style: { width: '49%', marginTop: 'auto' },
        id: `${form.length + 1}`,
        dependency: `documentType_${form.length + 1}`,
        dependencyAccessor: (obj) => obj?.value,
      },
    ]);
    setForm([...form]);
  };

  const handleDeleteForm = (formIndex) => {
    const filteredArray = clientDocs.filter(
      (item, idx) => idx !== formIndex && idx !== formIndex + 1 && idx !== formIndex - 1
    );
    setClientDocs(filteredArray);
    setShowModal(false);
  };

  const handleShowModal = (e, index, docName) => {
    e.preventDefault();
    e.stopPropagation();
    setDeletedDocument(docName ? docName.split('/').at(-1) : '');
    setDocumentIndex(index);
    setShowModal(true);
  };
  // Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ (ÑÐºÐ°Ð½)
  // ÐÐ°ÑÐ¿Ð¾ÑÑ (ÑÐºÐ°Ð½)
  // ÐÐ¾Ð´Ð¸ÑÐµÐ»ÑÑÐºÐ¾Ðµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ (ÑÐºÐ°Ð½)
  useEffect(() => {
    getClientDocuments({ userId: id })
      .then((res) => {
        res.data.forEach((item) => {
          clientDocs.push([
            {
              name: `documentType`,
              component: SelectClienDocumentTypes,
              label: 'Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
              style: { width: '46.2%' },
              defaultValue:
                item.typeId === 1
                  ? { value: 1, label: 'Ð£Ð´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ (ÑÐºÐ°Ð½)' }
                  : item.typeId === 2
                  ? { value: 2, label: 'ÐÐ°ÑÐ¿Ð¾ÑÑ (ÑÐºÐ°Ð½)' }
                  : { value: 3, label: 'ÐÐ¾Ð´Ð¸ÑÐµÐ»ÑÑÐºÐ¾Ðµ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ (ÑÐºÐ°Ð½)' },
              disabled: true,
            },
            {
              name: `document`,
              component: DocsInput,
              text: 'Ð¤Ð°Ð¹Ð» Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
              label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
              style: { width: '46.2%', marginTop: 'auto' },
              id: item.id,
              defaultValue: item.url,
            },
            {
              component: DeleteButton,
              name: `deleteBtn`,
              style: { marginTop: 'auto' },
              onClick: (e) => handleShowModal(e, item.id, item.url),
            },
          ]);
          setClientDocs([...clientDocs]);
        });
      })
      .finally(() => setLoading(false));
  }, []);

  useLayoutEffect(() => {
    setLoading(true);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
          {!clientDocs.length && (
            <p style={{ fontWeight: 400, fontSize: '16px', lineHeight: '20px', marginTop: '30px' }}>
              Ð£ ÑÑÐ¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð½ÐµÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²
            </p>
          )}
          {clientDocs.length > 0 &&
            clientDocs.map((item) => {
              return <HookForm inputs={item} grid={formStyles.documents} />;
            })}

          {!clientDocs.length ? (
            <Button text={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'} fill onClick={() => handleAddForm(clientDocs, setClientDocs)} />
          ) : (
            <AddButton text={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'} onClick={() => handleAddForm(clientDocs, setClientDocs)} />
          )}
          {showModal && (
            <ModalAccept
              document={deletedDocument}
              closeModal={() => setShowModal(false)}
              handleDeleteForm={() => handleDeleteForm(documentIndex)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ClientsDocs;
